import React from 'react';
import PropTypes from "prop-types";
import {useFormik} from "formik";

import {ResponsiveDialog} from "../../../../../components/ResponsiveDialog";
import guestValidationSchema from "./validator";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";


const FormEditGuest = (props) => {
    const {booking, isLoading, onSubmit, onClose} = props;

    const formik = useFormik({
        initialValues: {
            name: booking.name || '',
            surname: booking.surname || '',
            email: booking.email || '',
        },
        validationSchema: guestValidationSchema,
        onSubmit: values => {
            onSubmit(values);
        }
    });

    const submitIsEnabled = !Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <ResponsiveDialog title={"Modifica prenotazione"}
                          isOpen={true}
                          maxWidth="md"
                          scroll="paper"
                          isLoading={isLoading}
                          showApply={true}
                          applyLabel="Salva"
                          enableApply={submitIsEnabled}
                          onApply={formik.handleSubmit}
                          closeLabel="Cancella"
                          onClose={onClose}>

            <Grid container spacing={3} sx={{pt: 1}}>
                <Grid item xs={12} md={6}>
                    <TextField label="Cognome"
                               fullWidth
                               name="surname"
                               value={formik.values.surname}
                               onChange={formik.handleChange}
                               error={formik.touched.surname && Boolean(formik.errors.surname)}
                               helperText={formik.touched.surname && formik.errors.surname}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField label="Nome"
                               fullWidth
                               name="name"
                               value={formik.values.name}
                               onChange={formik.handleChange}
                               error={formik.touched.name && Boolean(formik.errors.name)}
                               helperText={formik.touched.name && formik.errors.name}/>
                </Grid>

                <Grid item xs={12}>
                    <TextField label="Email"
                               fullWidth
                               name="email"
                               value={formik.values.email}
                               onChange={formik.handleChange}
                               error={formik.touched.email && Boolean(formik.errors.email)}
                               helperText={formik.touched.email && formik.errors.email}/>
                </Grid>
            </Grid>
        </ResponsiveDialog>
    );
};

FormEditGuest.propTypes = {
    booking: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default FormEditGuest;